'use client';

import { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getTestimonialById } from '@/lib/actions/testimonials';
import { TestimonialForm } from '@/components/admin/testimonials/TestimonialForm';

export default function AdminTestimonialEditPage() {
  const { id } = useParams<{ id: string }>();
  const [testimonial, setTestimonial] = useState<Awaited<ReturnType<typeof getTestimonialById>>>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    getTestimonialById(id).then((data) => {
      setTestimonial(data);
      setLoading(false);
    });
  }, [id]);

  if (loading) {
    return null;
  }

  if (!testimonial) {
    return <Navigate to="/admin/testimonials" replace />;
  }

  return <TestimonialForm initialData={testimonial} />;
}
